(function () {
	var $optionsContainer = $("#swap_product_container");
	var $optionsPanel = $("#swap_product_options_panel");
	var $clickedSwapButton = null;
	var cachedCategories = {};
	var bundleIds = $("[data-add-bundle]").data("bundleIds").split(",");
	var currentBundleProductId = "";
	var originalBundleProducts = {};

	$(".product__superbundle .superbundle-product .listing__product").each(function() {
		if($(this).find(".swap-product-button").data("loopKey") != "undefined") {
			originalBundleProducts[$(this).find(".swap-product-button").data("loopKey")] = $(this).data("productId");
		}
	});


	if ($optionsContainer.length) {
		function openOptionsPanel() {
			$optionsPanel.find(".options").html("");
			$("html, body").addClass("force-noscroll");
			$optionsContainer.fadeIn(250, function () {
				$optionsPanel.css({
					right: "0px",
				});
			});

			$optionsContainer.addClass("loading-overlay");
		}

		function loadCategoryProducts() {
			var productId = originalBundleProducts[$clickedSwapButton.data("loopKey")];	
			currentBundleProductId = $clickedSwapButton.data("productId");		

			if(typeof cachedCategories[productId] == "undefined") {
				openOptionsPanel();
				$.ajax({
					type: "POST",
					url: window.jstransobj.linkPrefix + "/product/category-products",
					data: {
						"productId": productId,
						"mainProductId": $(".superbundle-product.main-product .listing__product").data("productId"),
						"categoryTagId": $clickedSwapButton.data("categoryTagId"),
						"key": $clickedSwapButton.data("loopKey")
					},
					success: function (response) {
						cachedCategories[productId] = response;
						populateOptions(response);
						markSelected(currentBundleProductId);
					}
				});
			} else {
				openOptionsPanel();
				setTimeout(function() {
					populateOptions(cachedCategories[productId]);
					markSelected(currentBundleProductId);
				}, 1000);
			}
		}

		function markSelected(productId) {
			$('#swap_product_options_panel .option').removeClass("selected");
			$('#swap_product_options_panel .option[data-product-id="'+ productId +'"]').addClass("selected");
		}

		function populateOptions(response) {
			$optionsPanel.replaceWith($(response.html).find("#swap_product_options_panel").css("right", 0));
			$optionsPanel = $("#swap_product_options_panel");

			$optionsContainer.removeClass("loading-overlay");
			attachFilter();
			attachOptionsEvents();
		}

		function attachOptionsEvents() {
			$('#swap_product_options_panel .option').on("click", function() {
				markSelected($(this).data("productId"));

				bundleIds[bundleIds.indexOf(currentBundleProductId.toString())] = $(this).data("productId").toString();
				closeOptionsPanel();
				requestNewBundle(bundleIds);
			});

			
		}

		function requestNewBundle(bundleIds) {
            $(".product__superbundle").addClass("loading-overlay");
			$.ajax({
				type: "POST",
				url: window.jstransobj.linkPrefix + "/product/create-bundle",
				data: {bundleIds: bundleIds, template: $("body").data("productTemplateName")},
				success: function (response) {
					var $res = $(response.html);
					$(".product__superbundle").html($res.html());
				},
				complete: function() {
					$(".product__superbundle").removeClass("loading-overlay");
				}
			});
		}

		function closeOptionsPanel() {
			$("html, body").removeClass("force-noscroll");
			$optionsPanel.css({
				right: "-360px",
			});
			$optionsContainer.fadeOut();
			$('#swap_product_container .search_through_panel__input').val("").trigger("keyup");
		}

		function attachFilter() {
			var $elementsToFilter = $('#swap_product_options_panel .option');
			var searchString = "";
			var foundElement = true;
		
			$('#swap_product_container .search_through_panel__input').keyup(function() {
				searchString = $(this).val().trim().split(" ");
				Array.prototype.forEach.call($elementsToFilter, function(el) {
		
					foundElement = true;
					searchString.forEach(function(text) {
						if($(el).find('.option_name').text().toLowerCase().indexOf(text.toLowerCase()) === -1) {
							foundElement = false;
						}
					});
					if(foundElement === true) {
						$(el).removeClass("hide");
					} else {
						$(el).addClass("hide");
					}
				});
			});
		}

		$(".product__superbundle").on("click", ".swap-product-button", function(e) {
			e.preventDefault();
			$clickedSwapButton = $(this);
			loadCategoryProducts();
		});

		$("body").on("click", "#swap_product_container .options_header", function () {
			closeOptionsPanel();
		});

		$optionsContainer.on("click", function (e) {
			if ($(e.target).attr("id") == "swap_product_container") {
				closeOptionsPanel();
			}
		});
	}
})();